import React, { Component } from 'react';
import { is, fromJS } from 'immutable';

import './loading.less';


class Loading extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        return !is(fromJS(this.props), fromJS(nextProps)) || !is(fromJS(this.state), fromJS(nextState))
    }

    componentDidMount() {

    }

    render() {
        return (
            <div className="loading">
                <div className="loading-empty">
                    <div className="loading">

                    </div>
                </div>
            </div>
        )
    }
}

export default Loading
